import React, {lazy, Suspense} from 'react'

const Page = lazy(() => import(/* webpackChunkName: "TagPage" */ './index'))

function LazyTagPage(props) {
  return (
    <Suspense fallback={null}>
      <Page {...props} />
    </Suspense>
  )
}

export default LazyTagPage
